<div class="generic-list">
  <ul id="items-list">
    <li class="item" *ngFor="let item of items$ | async; trackBy: trackByFn" >
      <ng-container *ngIf="item.enable !== false">
        <label>{{item.label}}</label>
        <span class="chevron-icon icon__NavigationDown1"></span>
      </ng-container>
    </li>
  </ul>
</div>



